//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Multiplier } from '../wheel.entity';

export default {
  name: 'WheelHomeBetContentNew',
  props: {
    // 选中的倍率值（支持 v-model）
    value: {
      type: String,
      default: Multiplier.X2
    },
    // 是否启用主播模式
    streamerMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Multiplier,
      internalColor: this.value
    };
  },
  computed: {
    activeColor() {
      return this.value !== undefined ? this.value : this.internalColor;
    }
  },
  watch: {
    value(newVal) {
      this.internalColor = newVal;
    }
  },
  methods: {
    setColor(color) {
      this.internalColor = color;
      this.$emit('input', color);
      this.$emit('change', color);
    },
    formatMultiplier(val) {
      if (this.streamerMode) {
        return val.replace(/x/gi, '');
      }
      return val;
    }
  }
};
